import { Invite, Member } from '@/types'
import { isAdminRole } from '@/utils/role'

export const sortMembers = (members: Member[]) => {
  return [...members].sort((a, b) => {
    // Admin-level roles (admin, superadmin, it_admin) take prio
    const aIsAdmin = isAdminRole(a.role)
    const bIsAdmin = isAdminRole(b.role)
    if (aIsAdmin && !bIsAdmin) return -1
    if (!aIsAdmin && bIsAdmin) return 1

    // No roles are last (to catch cases where our internal team manually edits enterprise_id without updating role)
    if (!a.role && b.role) return 1
    if (a.role && !b.role) return -1

    return a.email.localeCompare(b.email)
  })
}

export const sortInvites = (invites: Invite[]) => {
  // Invites are agnostic to role
  return [...invites].sort((a, b) => {
    return a.email.localeCompare(b.email)
  })
}
